import React from "react";
import { useTranslation } from "react-i18next";
import BtnAppStore from "../../components/BtnAppStore";
import BtnPlayStore from "../../components/BtnPlayStore";
import Commentaires from "../../components/Commentaires";
import AppPlayLink from "../../components/AppPLayLink";

const RendezVous = () => {
  const { t } = useTranslation();
  return (
    <main>
      <section id="landing">
        <div id="container" className="pt-24 px-5 lg:px-16">
          <div
            className=" w-full px-6 lg:pl-12 pt-8 pb-8 lg:pb-0 rounded-3xl gradient text-white text-center lg:text-left
          lg:flex gap-8 "
          >
            <div className="mb-6 flex flex-col lg:w-[60%] lg:pt-10">
              <h1 className="  font-extrabold mb-4 text-3xl">
                {t("rdv.hero.titreHero")}
              </h1>
              <p className=" mb-4">{t("rdv.hero.paraph")}</p>
              <p className="font-bold mb-4">{t("rdv.hero.telecharger")}</p>
              <div className="flex *:h-12 gap-4 lg:justify-start justify-center">
                <BtnAppStore />
                <BtnPlayStore />
              </div>
            </div>
            <div className="hidden lg:flex justify-center  ">
              <img
                src="/assets/images/prise de redez vous/hero.png"
                alt=""
                className="w-[350px] lg:w-[500px]"
              />
            </div>
          </div>
        </div>
      </section>

      <section>
        <div id="container" className="px-5 py-10 lg:px-16 relative">
          <h1 className="text-2xl mb-4 font-bold text-center text-blue-primary ">
            {t("rdv.section2.titre")}
          </h1>
          <div className="flex flex-col items-center ">
            <div className="lg:flex lg:mb-32 lg:mt-28  lg:w-full  justify-between items-center">
              <div
                className="flex mb-4 lg:mb-0 items-center px-4 py-2 border-2
               border-blue-primary rounded-3xl gap-4 font-semibold"
              >
                <div
                  className="bg-blue-primary rounded-full w-8 h-8 text-white
              text-xl flex justify-center items-center font-bold "
                >
                  <span>1</span>
                </div>
                <p>{t("rdv.section2.paraph1")}</p>
              </div>

              <div
                className="flex   items-center px-4 py-2 border-2
               border-blue-primary rounded-3xl gap-4 font-semibold"
              >
                <div
                  className="bg-blue-primary rounded-[100%] w-8 h-8 text-white
              text-xl flex justify-center items-center font-bold "
                >
                  <span>2</span>
                </div>
                <p>{t("rdv.section2.paraph2")}</p>
              </div>
            </div>

            <div className="lg:absolute my-20 h-72 w-72 gradient rounded-[100%] relative">
              <img
                src="/assets/images/prise de redez vous/phone_14_01.png"
                alt="phone"
                className="w-48 absolute bottom-1/2 translate-y-1/2 left-1/2 -translate-x-1/2"
              />
            </div>

            <div className="lg:flex lg:mb-12 justify-between items-center lg:w-full">
              <div
                className="flex mb-4 lg:mb-0  items-center px-4 py-2 border-2
               border-blue-primary rounded-3xl gap-4 font-semibold"
              >
                <div
                  className="bg-blue-primary rounded-full w-8 h-8 text-white
              text-xl flex justify-center items-center font-bold "
                >
                  <span>1</span>
                </div>
                <p>{t("rdv.section2.paraph3")}</p>
              </div>

              <div
                className="flex   items-center px-4 py-2 border-2
               border-blue-primary rounded-3xl gap-4 font-semibold"
              >
                <div
                  className="bg-blue-primary rounded-full w-8 h-8 text-white
              text-xl flex justify-center items-center font-bold "
                >
                  <span>1</span>
                </div>
                <p>{t("rdv.section2.paraph4")}</p>
              </div>
            </div>
          </div>
          <div></div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="container  flex flex-col items-center px-6 mx-auto space-y-8 lg:flex-row lg:px-12 lg:space-y-0 lg:space-x-12">
          {/* Image Section */}
          <div className=" hidden lg:flex justify-center flex-1">
            <div className="relative w-full max-w-xs md:max-w-md lg:max-w-lg">
              {/* Cercle bleu */}
              <div className="absolute w-40 h-40 rounded-full bg-blue-primary md:w-56 md:h-56 md:top-20 md:left-20 top-10 left-10"></div>
              {/* Cercle vert */}
              <div className="absolute w-40 h-40 rounded-full bg-primary-green md:w-56 md:h-56 md:top-24 top-14 md:left-14 left-7"></div>
              {/* Téléphone */}
              <img
                src="/assets/images/prise de redez vous/phone.png"
                alt="phone"
                className="relative z-10 w-[60%]"
              />
            </div>
          </div>

          {/* Texte Section */}
          <div className="flex-1 text-center lg:text-left">
            <h2 className="mb-4 text-2xl font-bold text-blue-900 md:text-3xl lg:text-4xl">
             {t('rdv.section3.titre')}
            </h2>
            <p className="mb-6 text-sm leading-relaxed text-gray-700 md:text-base">
            {t('rdv.section3.paraph')}
            </p>
           <div className="flex justify-center lg:justify-start">
            <AppPlayLink />
           </div>
          </div>


          <div className="flex justify-center flex-1 lg:hidden">
            <div className="relative w-full max-w-xs md:max-w-md lg:max-w-lg">
              {/* Cercle bleu */}
              <div className="absolute w-40 h-40 rounded-full bg-blue-primary md:w-56 md:h-56 md:top-20 md:left-20 top-10 left-10"></div>
              {/* Cercle vert */}
              <div className="absolute w-40 h-40 rounded-full bg-primary-green md:w-56 md:h-56 md:top-24 top-14 md:left-14 left-7"></div>
              {/* Téléphone */}
              <img
                src="/assets/images/prise de redez vous/phone.png"
                alt="phone"
                className="relative z-10 w-[60%]"
              />
            </div>
          </div>
        </div>
      </section>

      <section>
        <Commentaires />
      </section>
    </main>
  );
};

export default RendezVous;
